// src/pages/OrderStep2.js
import { useLocation, useNavigate } from 'react-router-dom';
import { useContext, useEffect, useState } from 'react';
import api from '../api/axios';
import { AuthContext } from '../context/AuthContext';

export default function OrderStep2() {
  const { token } = useContext(AuthContext);
  const navigate = useNavigate();
  const { state } = useLocation();
  const { addressId, cart } = state || {};

  const [summary, setSummary] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!addressId || !cart || cart.length === 0) {
      navigate('/order-step-1');
      return;
    }

    if (!navigator.geolocation) {
      alert('Geolocation not supported by your browser');
      navigate('/order-step-1');
      return;
    }

    navigator.geolocation.getCurrentPosition(
      async (pos) => {
        const lat = pos.coords.latitude;
        const lng = pos.coords.longitude;

        try {
          const res = await api.post(
            '/place-order/',
            {
              items: cart.map(c => ({ medicine_id: c.id, quantity: c.qty || 1 })),
              address_id: addressId,
            },
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );

          const order = res.data.order || res.data;
          const orderSummary = {
            orderId: order.id,
            orderStringId: order.order_id,
            addressId,
            medicines: cart,
            lat,
            lng,
            deliveryFee: res.data.delivery_charge || order.delivery_charge,
            total: res.data.total || order.total_amount,
          };

          localStorage.setItem('order_summary', JSON.stringify(orderSummary));
          setSummary(orderSummary);
        } catch (err) {
          alert(err?.response?.data?.error || 'Error calculating summary. Redirecting...');
          navigate('/order-step-1');
        } finally {
          setLoading(false);
        }
      },
      (err) => {
        alert('Location access denied. Please allow location and try again.');
        navigate('/order-step-1');
        setLoading(false);
      }
    );
  }, [addressId, cart, navigate, token]);

  const goToStep3 = () => navigate('/order-step-3');

  if (loading) return <p style={{ padding: 20 }}>Calculating summary...</p>;
  if (!summary) return null;

  const totalQty = summary.medicines.reduce((sum, m) => sum + m.qty, 0);

  return (
    <div className="container" style={{ maxWidth: 600, marginTop: 30 }}>
      <h3>Order Summary</h3>
      <p><strong>Total Items:</strong> {totalQty}</p>
      <p><strong>Delivery Fee:</strong> ₹{summary.deliveryFee}</p>
      <h4><strong>Total Payable:</strong> ₹{summary.total}</h4>

      <button
        onClick={goToStep3}
        style={{
          marginTop: 20,
          padding: '10px 20px',
          backgroundColor: '#1a73e8',
          color: '#fff',
          border: 'none',
          borderRadius: 6,
          cursor: 'pointer',
        }}
      >
        Proceed to Payment
      </button>
    </div>
  );
}
